import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCargoInformationList(params) {
  return request({
    url: URL.mdm.basicData.cargoInformation,
    method: 'get',
    params
  })
}

export function saveCargoInformation(data) {
  return request({
    url: URL.mdm.basicData.cargoInformation,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCargoInformation(uuid) {
  return request({
    url: URL.mdm.basicData.cargoInformation + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
